(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', init);

  function init() {
    (window.remoteProgrammingKeysConfig || []).forEach(setupInstance);
  }

  function setupInstance(config) {
    var root = document.querySelector(config.rootSelector);
    if (!root) return;

    if (!window.ProductAddonsCore) {
      console.error('remote-programming-keys-selector: ProductAddonsCore not found — make sure product-addons-core.js loads first');
      return;
    }

    var form = root.closest('form[data-product-form]') || root.closest('form[action*="/cart/add"]');
    var mainIdInput = form ? form.querySelector('[name="id"]') : null;

    var scannerSelect = root.querySelector('[data-remote-keys-scanner]');
    var keysContainer = root.querySelector('[data-remote-keys-keys]');
    var errorEl = root.querySelector('[data-remote-keys-error]');
    var scanners = config.scanners || [];
    var selectedKeys = {}; // key label -> true; reset whenever scanner changes

    if (!scanners.length || !mainIdInput) {
      showError('Scanner/key options are not configured correctly. Contact support.');
      console.error('remote-programming-keys-selector: scanners config is empty, or no enclosing product form with [name="id"] was found');
      window.ProductAddonsCore.register(root, function () {
        showError('Scanner/key options are not configured correctly. Contact support.');
        return { ok: false };
      });
      return;
    }

    populateScanners();

    scannerSelect.addEventListener('change', function () {
      selectedKeys = {};
      renderKeys(scannerSelect.value);
      applyScannerVariant(scannerSelect.value);
      clearError();
    });

    // No price provider passed (third argument omitted) — this widget
    // never contributes to the live "configured price" display. The
    // first county is already included in the product's own price.
    window.ProductAddonsCore.register(root, getContribution);

    function populateScanners() {
      scanners.forEach(function (entry) {
        var option = document.createElement('option');
        option.value = entry.scanner;
        option.textContent = entry.scanner;
        scannerSelect.appendChild(option);
      });
    }

    function applyScannerVariant(scanner) {
      var entry = scanners.filter(function (s) { return s.scanner === scanner; })[0];
      if (entry && mainIdInput) {
        mainIdInput.value = entry.representativeVariantId;
      }
    }

    function renderKeys(scanner) {
      keysContainer.innerHTML = '';
      if (!scanner) return;

      var entry = scanners.filter(function (s) { return s.scanner === scanner; })[0];
      var keys = entry ? entry.keys : [];

      keys.filter(function (key) { return !!key; }).forEach(function (key) {
        var chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'product__chip';
        chip.dataset.key = key;
        chip.setAttribute('aria-pressed', 'false');
        chip.textContent = key;
        chip.addEventListener('click', function () {
          var isNowSelected = !selectedKeys[key];
          if (isNowSelected) {
            selectedKeys[key] = true;
          } else {
            delete selectedKeys[key];
          }
          chip.classList.toggle('selected', isNowSelected);
          chip.setAttribute('aria-pressed', isNowSelected ? 'true' : 'false');
          clearError();
        });
        keysContainer.appendChild(chip);
      });
    }

    // Called by ProductAddonsCore when the shopper clicks add-to-cart.
    // A scanner MUST be selected — that's what determines the real SKU
    // being purchased, unlike keys, which stay optional/informational.
    function getContribution() {
      clearError();

      var scanner = scannerSelect.value;
      if (!scanner) {
        showError('Please select your scanner.');
        root.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return { ok: false };
      }

      var keys = Object.keys(selectedKeys);
      var properties = { 'Scanner': scanner };
      if (keys.length) {
        properties['Keys Currently Installed'] = keys.join(', ');
      }

      return {
        ok: true,
        items: [],
        mainItemProperties: properties
      };
    }

    function showError(msg) { errorEl.textContent = msg; errorEl.hidden = false; }
    function clearError() { errorEl.textContent = ''; errorEl.hidden = true; }
  }
})();